var strip = function (value) {
    // eslint-disable-next-line prefer-regex-literals
    return value.replaceAll(new RegExp('[^0-9a-zA-Z- ]+', 'g'), '').replaceAll(' ', '-').toLowerCase();
};
export { strip };
